import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, inject } from '@angular/core';
import { Fridge } from '../../models/Fridge';
import { FridgeSubSystemState } from 'package-types/index';
import { UserService } from 'src/app/services/user/user.service';
import { Subscription } from 'rxjs';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { InstallLabelParts, getInstallLabel, getInstallLabelParts } from 'src/app/utils/install-label';

@Component({
  selector: 'app-fridge-list',
  templateUrl: './fridge-list.component.html',
  styleUrls: ['./fridge-list.component.scss'],
  standalone: false,
})
export class FridgeListComponent implements OnInit, OnChanges, OnDestroy {
  userService = inject(UserService);
  settings = inject(SettingsService);

  @Input('fridge') fridge: Fridge;
  /** false inside a merchant section of the list: the section title already has the merchant */
  @Input() showMerchant = true;
  @Output() selectFridge: EventEmitter<string> = new EventEmitter();
  labelParts: InstallLabelParts = { number: '', merchant: '', name: '' };
  /** the full label, e.g. for the tooltip */
  label = '';
  private merchantsSubscription: Subscription;

  constructor() {
    this.merchantsSubscription = this.userService.merchantsChange.subscribe(() => {
      this.updateLabel();
    });
  }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fridge || changes.showMerchant) {
      this.updateLabel();
    }
  }

  ngOnDestroy(): void {
    this.merchantsSubscription?.unsubscribe();
  }

  onFridgeSelect(id: string | undefined) {
    this.selectFridge.emit(id);
  }

  get tabletVersion(): string {
    if (!this.userService.isAuthenticated || !this.userService.isInternal) {
      return '';
    }
    // both parts of the version are always the same, e.g. "91.91"
    return this.fridge?.tabletInfo?.version?.split('.')[0] || '';
  }

  private updateLabel(): void {
    const merchant = this.fridge ? this.userService.getMerchantById(this.fridge.merchantId as unknown as string) : undefined;
    this.labelParts = getInstallLabelParts(this.fridge, merchant, { withMerchant: this.showMerchant });
    this.label = getInstallLabel(this.fridge, merchant, { isInternal: this.isInternalUser });
  }

  private get isInternalUser(): boolean {
    return !!this.userService.userData && this.userService.isInternal;
  }

  protected readonly FridgeSubSystemState = FridgeSubSystemState;
}
